import { NewsletterService, NewsletterError } from '@/services/newsletter.service'
import ApiService from '@/services/api.service'

const state =  {
    loading: false,
    newsletters: [],
    subscriptions: [],
    nextPage: 1,
    total: 0,
    pages: 0,
    sereverResponse: null,
}

const getters = {

    loading: (state) => {
        return state.loading
    },

    newsletters: (state) => {
        return state.newsletters
    },

    subscriptions: (state) => {
        return state.subscriptions
    },
 
    nextPage: (state) => {
        return state.nextPage
    },

    total: (state) => {
        return state.total
    },

    pages: (state) => {
        return state.pages
    },

    sereverResponse: (state) => {
        return state.sereverResponse
    },
}


const actions = {
    
    async fetchNewsletters({ commit }, { page }) {
        commit('newsletterFetchAllRequest')

        try {
            const response = await NewsletterService.fetchAll(page);
            if (response.hasOwnProperty('newsletters')) {
                commit('newsletterFetchAllSuccess', response)
                commit('incrementNextPage')

                return true
            } else {
                commit('newsletterFetchAllError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('newsletterFetchAllError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async createNewsletter({ commit }, { data }) {  
        commit('startRequest')

        try {
            const response = await NewsletterService.createNewsletter(data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                let newsletter = await NewsletterService.fetchNewsletter(response.id)
                if (newsletter.id > 0) {
                    commit('newsletterCreateSuccess', newsletter)
                }
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {

            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async fetchNewsletter({ commit }, { id }) {  
        commit('startRequest')
        
        try {
            let newsletter = await NewsletterService.fetchNewsletter(id)
            if (newsletter.id > 0) {
                commit('newsletterReloadSuccess', newsletter)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } 
        catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async updateNewsletter({ commit }, { data, id }) {  
        commit('startRequest')
        
        try {
            const response = await NewsletterService.updateNewsletter(data, id)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                data.id = id
                commit('newsletterUpdateSuccess', data)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteNewsletter({ commit }, { id }) {
        commit('startRequest')

        try {
            const response = await NewsletterService.deleteNewsletter(id);
            if (response.status === 'success') {
                commit('deleteNewsletterSuccess', [id])

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteMultipleNewsletters({ commit }, { ids }) {
        commit('startRequest')

        try {
            const response = await NewsletterService.deleteMultipleNewsletters(ids)
            if (response.status === 'success') {
                commit('deleteNewsletterSuccess', ids)

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async addSubscriber({ commit }, { data, newsletterId}) {
        commit('startRequest')

        try {
            const response = await NewsletterService.addSubscriber(newsletterId, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                let subscriber = await NewsletterService.fetchSubscriber(newsletterId, response.id)
                if (subscriber.id > 0) {
                    commit('addSubscriberSuccess', subscriber)
                }
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
           
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async addSubscriberBulk({ commit }, { data, newsletterId}) {
        commit('startRequest')

        try {
            const response = await NewsletterService.addSubscriberBulk(newsletterId, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                commit('stopRequest', response)
                return true
            } else {
                commit('stopRequest', response)
                return false
            }
        }
        catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async fetchNewsletterSubscribers({ commit }, { newsletterId, page }) {
        commit('newsletterFetchAllRequest')

        try {
            const response = await NewsletterService.fetchSubscribers(newsletterId, page)
            response.newsletterId = newsletterId
            commit('newsletterSubscribersFetchAllSuccess', response)
            commit('incrementSubscriberNextPage', newsletterId)

            return true
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('newsletterFetchAllError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async updateSubscriber({ commit }, { data, newsletterId, id}) {
        commit('startRequest')

        try {
            const response = await NewsletterService.updateSubscriber(newsletterId, id, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                data.newsletterId = newsletterId
                data.id = id
                commit('updateSubscriberSuccess', data)

                return true
            } else {
                commit('requestError', response)
                return false
            }
        } 
        catch (e) {
           
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteSubscriber({ commit }, { newsletterId, id }) {
        commit('startRequest')

        try {
            const response = await NewsletterService.deleteSubscriber(newsletterId, id)
            if (response.status === 'success') {
                commit('deleteSubscriberSuccess', {id:newsletterId, subscriberIds: [id]})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteMultipleSubscribers({ commit }, { newsletterId, ids }) {
        commit('startRequest')

        try {
            const response = await NewsletterService.deleteMultipleSubscribers(newsletterId, ids)
            if (response.status === 'success') {
                commit('deleteSubscriberSuccess', {id:newsletterId, subscriberIds: ids})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async saveFollowup({ commit }, { data, newsletterId}) {
        commit('startRequest')

        try {
            const response = await NewsletterService.saveFollowup(newsletterId, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                let followup = await NewsletterService.fetchFollowup(newsletterId, response.id)
                if (followup.id > 0) {
                    commit('addFollowupSuccess', followup)
                }
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
           
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async updateFollowup({ commit }, { data, newsletterId, id}) {
        commit('startRequest')

        try {
            const response = await NewsletterService.updateFollowup(newsletterId, id, data)
            if (response.code == ApiService.SUCCESS_RESPONSE_CODE) {
                data.newsletterId = newsletterId
                data.id = id
                commit('updateFollowupSuccess', data)
                return true
            } else {
                commit('requestError', response)
                return false
            }
        } catch (e) {
           
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async fetchNewsletterFollowups({ commit }, { newsletterId, page }) {
        commit('newsletterFetchAllRequest')
        try {
            const response = await NewsletterService.fetchFollowups(newsletterId, page)
            response.newsletterId = newsletterId
            commit('newsletterFollowupsFetchAllSuccess', response)
            commit('incrementFollowupNextPage', newsletterId)

            return true
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('newsletterFetchAllError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteFollowup({ commit }, { newsletterId, id }) {
        commit('startRequest')

        try {
            const response = await NewsletterService.deleteFollowup(newsletterId, id)
            if (response.status === 'success') {
                commit('deleteFollowupSuccess', {id:newsletterId, followupIds: [id]})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
    
    async deleteMultipleFollowups({ commit }, { newsletterId, ids }) {
        commit('startRequest')

        try {
            const response = await NewsletterService.deleteMultipleFollowups(newsletterId, ids)
            if (response.status === 'success') {
                commit('deleteFollowupSuccess', {id:newsletterId, followupIds: ids})

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async fetchSubscriptions({ commit }) {
        commit('startRequest')
        
        try {
            const response = await NewsletterService.fetchSubscriptions()
            if (response.hasOwnProperty('subscriptions')) {
                commit('subscriptionsFetchSuccess', response)

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async findBySubcode({ commit }, {subcode}) {
        commit('startRequest')

        try {
            const response = await NewsletterService.findBySubcode(subcode)
            commit('stopRequest', response)
            return response
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return null
        }
    },

    async subscribe({ commit }, { data }) {
        commit('startRequest')

        try {
            const response = await NewsletterService.subscribe(data)
            if (response.status === 'success') {
                commit('stopRequest', response)

                return true
            } else {
                commit('requestError', response)
                
                return false
            }
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },

    async unsubscribe({ commit }, { data }) {
        commit('startRequest')

        try {
            const response = await NewsletterService.unsubscribe(data)
            if (response.status === 'success') {
                commit('unsubscribeSuccess', data.subcode)

                return true
            }
            commit('requestError', response)
                
            return false
        } catch (e) {
            if (e instanceof NewsletterError) {
                commit('requestError', {status: e.errorCode, message: e.message})
            }

            return false
        }
    },
}

const mutations = {
    newsletterFetchAllRequest(state) {
        state.loading = true
        state.sereverResponse = null
    },

    newsletterFetchAllSuccess(state, response) {
        for( let i = 0; i < response.newsletters.length; i++){ 
            let flag = false
            for (let j = 0; j < state.newsletters.length; j++) {
                if (state.newsletters[j].id === response.newsletters[i].id) {
                    flag = true
                    break
                }
            }
            if (!flag) {
                response.newsletters[i].marked = false
                response.newsletters[i].subscribers = []
                response.newsletters[i].subscriber_pages = 0
                response.newsletters[i].subscribers_total = 0
                response.newsletters[i].subscribers_next_page = 1
                response.newsletters[i].followups = []
                response.newsletters[i].followup_pages = 0
                response.newsletters[i].followups_total = 0
                response.newsletters[i].followups_next_page = 1
                state.newsletters.push(response.newsletters[i])   
            }
        }
        state.total = response.total
        state.pages = response.pages
        state.loading = false;
    },

    newsletterSubscribersFetchAllSuccess(state, response) {
        for (let i = 0; i < state.newsletters.length; i++) {
            if (state.newsletters[i].id === response.newsletterId) {
                for (let j = 0; j < response.subscribers.length; j++) {
                    state.newsletters[i].subscribers.push(response.subscribers[j])
                    state.newsletters[i].subscribers_total++
                }
                state.newsletters[i].subscriber_pages = response.pages
                break
            }
        }
        state.loading = false
    },

    newsletterFetchAllError(state, {errorCode, errorMessage}) {
        state.loading = false
        state.errorCode = errorCode
        state.errorMessage = errorMessage
    },

    startRequest(){
       state.loading = true
       state.sereverResponse
    },

    stopRequest(response){
       state.loading = false 
       state.sereverResponse = response
    },

    newsletterCreateSuccess(state, newsletter) {
        state.loading = false;
        newsletter.subscribers = []
        newsletter.followups = []
        newsletter.marked = false
        newsletter.subscriber_pages = 0
        newsletter.subscribers_total = 0
        newsletter.subscribers_next_page = 1
        newsletter.followup_pages = 0
        newsletter.followups_total = 0
        newsletter.followups_next_page = 1

        state.newsletters.unshift(newsletter)
        state.total++
    },

    newsletterReloadSuccess(state, newsletter) {
        state.loading = false;
        newsletter.subscribers = []
        newsletter.followups = []
        newsletter.marked = false
        newsletter.subscriber_pages = 0
        newsletter.subscribers_total = 0
        newsletter.subscribers_next_page = 1
        newsletter.followup_pages = 0
        newsletter.followups_total = 0
        newsletter.followups_next_page = 1

        for( let i = 0; i < state.newsletters.length; i++){ 
            if ( state.newsletters[i].id === newsletter.id) {
                state.newsletters[i] = newsletter
                break;
            }
         }
        state.loading = false
    },

    newsletterUpdateSuccess(state, newsletter) {
        for( let i = 0; i < state.newsletters.length; i++){ 
            if ( state.newsletters[i].id === newsletter.id) {
                state.newsletters[i].name = newsletter.name
                state.newsletters[i].description = newsletter.description
                state.newsletters[i].third_party_id = newsletter.third_party_id
                break
            }
        }      
        
        state.loading = false
    },

    deleteNewsletterSuccess(state, ids) {
        for (let h = 0; h < ids.length; h++) {
            for( let i = 0; i < state.newsletters.length; i++){ 
                if ( state.newsletters[i].id === ids[h]) {
                    state.newsletters.splice(i, 1)
                    state.total--
                    i--
                    break
                }
            }            
        }
        
        state.loading = false
    },

    addSubscriberSuccess(state, subscriber) {
        for( let i = 0; i < state.newsletters.length; i++){ 
            if ( state.newsletters[i].id === subscriber.newsletter_id) {
                state.newsletters[i].subscribers.unshift(subscriber) 
                state.newsletters[i].subscribers_total++
                break;
            }
         }
        state.loading = false
    },

    updateSubscriberSuccess(state, subscriber) {
        for (let h = 0; h < state.newsletters.length; h++) {
            if (state.newsletters[h].id == subscriber.newsletterId) {
                for( let i = 0; i < state.newsletters[h].subscribers.length; i++){   
                    if ( state.newsletters[h].subscribers[i].id === subscriber.id) {
                        state.newsletters[h].subscribers[i].name = subscriber.name
                        break
                    } 
                }   
            }        
        }
        
        state.loading = false
    },

    deleteSubscriberSuccess(state, newsletter) {
        for (let h = 0; h < state.newsletters.length; h++) {
            if (state.newsletters[h].id == newsletter.id) {
                for (let i = 0; i < newsletter.subscriberIds.length; i++) {
                    for( let j = 0; j < state.newsletters[h].subscribers.length; j++){   
                        if ( state.newsletters[h].subscribers[j].id === newsletter.subscriberIds[i]) {
                            state.newsletters[h].subscribers.splice(j, 1)
                            state.newsletters[h].subscribers_total--
                            j--
                            break
                        } 
                    }
                }    
            }        
        }
        
        state.loading = false
    },

    addFollowupSuccess(state, followup) {
        for( let i = 0; i < state.newsletters.length; i++){ 
            if ( state.newsletters[i].id === followup.newsletter_id) {
                state.newsletters[i].followups.push(followup) 
                state.newsletters[i].followups_total++
                break;
            }
         }
        state.loading = false
    },

    updateFollowupSuccess(state, followup) {
        for (let h = 0; h < state.newsletters.length; h++) {
            if (state.newsletters[h].id == followup.newsletterId) {
                for( let i = 0; i < state.newsletters[h].followups.length; i++ ){   
                    if ( state.newsletters[h].followups[i].id === followup.id ) {
                        state.newsletters[h].followups[i].sender = followup.sender
                        state.newsletters[h].followups[i].message = followup.message
                        state.newsletters[h].followups[i].interval_after_prev = followup.interval_after_prev
                        state.newsletters[h].followups[i].followup_interval_id = followup.followup_interval_id
                        break
                    } 
                }   
            }        
        }
        
        state.loading = false
    },

    newsletterFollowupsFetchAllSuccess(state, response)
    {
        for (let i = 0; i < state.newsletters.length; i++) {
            if (state.newsletters[i].id === response.newsletterId) {
                for (let j = 0; j < response.followups.length; j++) {
                    state.newsletters[i].followups.push(response.followups[j])
                    state.newsletters[i].followups_total++
                }
                state.newsletters[i].followup_pages = response.pages
                break
            }
        }
        state.loading = false;
    },

    deleteFollowupSuccess(state, newsletter) {
        for (let h = 0; h < state.newsletters.length; h++) {
            if (state.newsletters[h].id == newsletter.id) {
                for (let i = 0; i < newsletter.followupIds.length; i++) {
                    for( let j = 0; j < state.newsletters[h].followups.length; j++){   
                        if ( state.newsletters[h].followups[j].id === newsletter.followupIds[i]) {
                            state.newsletters[h].followups.splice(j, 1)
                            state.newsletters[h].followups_total--
                            j--
                            break
                        } 
                    }
                }    
            }        
        }
        
        state.loading = false
    },

    requestError(state, response) {
        state.loading = false
        state.sereverResponse = response
    },

    incrementNextPage(state) {
        state.nextPage++
    },

    incrementSubscriberNextPage(state, newsletterId) {
        for (let h = 0; h < state.newsletters.length; h++) {
            if (state.newsletters[h].id == newsletterId) {
                state.newsletters[h].subscribers_next_page++
                break 
            }
        }    
    },

    incrementFollowupNextPage(state, newsletterId) {
        for (let h = 0; h < state.newsletters.length; h++) {
            if (state.newsletters[h].id == newsletterId) {
                state.newsletters[h].followups_next_page++
                break
            }
        } 
    },

    subscriptionsFetchSuccess(state, response) {
        state.subscriptions = response.subscriptions
        state.loading = false;
    },

    unsubscribeSuccess(state, subcode) {
        for (let i = 0; i < state.subscriptions.length; i++) {
            if (state.subscriptions[i].subcode == subcode) {
                state.subscriptions.splice(i, 1)
                break
            }  
        }
        
        state.loading = false;
    },
}

export const newsletter = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}